<template>
  <b-container fluid>
    <b-row no-gutters class="bordered-box">
      <b-col md="2" order-md="3" class="text-right">
        <b-button class="btn btn-danger delete-item" @click.prevent="deleteItem">
          <font-awesome-icon icon="trash-alt" size="xs"></font-awesome-icon>
        </b-button>
      </b-col>
      <b-col md="5" order-md="1">
        <span class="label">Data zaksięgowania</span>
        <span class="value">{{item.bookedDate | datetime}}</span>
      </b-col>
      <b-col md="5" order-md="2">
        <span class="label">Wysokość wpłaty</span>
        <span class="value">{{item.amount | money | replaceDotsWithCommas}}</span>
      </b-col>
    </b-row>
  </b-container>
</template>
<style lang="scss" scoped>
.bordered-box {
  border: 1px solid rgba(0, 0, 0, 0.125);
  border-radius: 5px;
  padding: 7px;
  margin: 3px;
  background: rgba(0, 0, 0, 0.03);
}
.container-fluid {
  padding: 0px;
}
.delete-item {
  padding: 3px 10px;
  margin-bottom: 5px;
}
.label {
  font-weight: 600;
}
.value {
  font-style: italic;
  display: block;
  margin-bottom: 10px;
}
</style>
<script>
import moment from "moment";
export default {
  props: ["item"],
  data() {
    return {};
  },
  methods: {
    deleteItem() {
      this.$emit("delete", this.item.id);
    },
    moment: function() {
      return moment();
    }
  },

  filters: {
    datetime(date) {
      return date ? moment(date).format("YYYY-MM-DD HH:mm") : "-";
    },
    money(value) {
      return parseFloat(value).toFixed(2) + " PLN";
    }
  }
};
</script>
